import React from "react";
import { useLocation } from "react-router-dom";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import { useFetch } from "@/lib/useData";

export default function LegalPage({ slug, fallbackTitle, fallbackDescription }) {
  const { pathname } = useLocation();
  const { data } = useFetch(`/pages/${slug}`, [slug]);
  const title = data?.seo?.title || data?.title || fallbackTitle;
  const desc = data?.seo?.description || fallbackDescription;
  const body = data?.body_html || "";

  return (
    <>
      <SEO title={title} description={desc} path={pathname} />
      <Breadcrumbs />
      <section className="bg-white pt-4 pb-12" data-testid={`legal-hero-${slug}`}>
        <div className="container max-w-4xl">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-semibold text-teal">
            <span className="h-px w-6 bg-teal" /> Legal
          </span>
          <h1 className="mt-5 font-display font-bold text-4xl md:text-6xl text-navy-800 tracking-tight">
            {data?.title || fallbackTitle}
          </h1>
        </div>
      </section>
      <section className="bg-soft-gray py-16 lg:py-20">
        <div className="container max-w-3xl">
          <article
            data-testid={`legal-body-${slug}`}
            className="prose prose-navy max-w-none prose-headings:font-display prose-h2:font-semibold prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-4 prose-h2:text-navy-800 prose-a:text-teal hover:prose-a:underline rounded-3xl bg-white border border-navy-50 p-8 lg:p-12"
            dangerouslySetInnerHTML={{ __html: body || `<p class="text-navy-500">${fallbackDescription}</p>` }}
          />
        </div>
      </section>
    </>
  );
}
